module.exports = __webpack_public_path__ + "img/gobierno-facil.bd2b2521.png";